import type { DefaultIconProps } from '../../../utils';
import { DefaultIconWrapper, getSemanticTextColor } from '../../../utils';

export const ExternalLinkIcon = ({
  width = 22,
  color = 'foraBlue',
  marginLeft,
  containerSize,
  title,
  style,
}: DefaultIconProps & { style?: object }) => (
  <DefaultIconWrapper marginLeft={marginLeft} containerSize={containerSize} width={width} title={title} style={style}>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 22 22">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.96955 5.33934C7.46747 5.33934 7.06046 4.93233 7.06046 4.43025V1.90909L7.0751 1.74568C7.15208 1.32159 7.52326 1 7.96955 1H20.0908L20.2542 1.01465C20.6783 1.09162 20.9999 1.4628 20.9999 1.90909V14.0303L20.9852 14.1937C20.9082 14.6178 20.5371 14.9394 20.0908 14.9394H17.5209L17.3575 14.9247C16.9334 14.8478 16.6118 14.4766 16.6118 14.0303L16.6265 13.8669C16.7034 13.4428 17.0746 13.1212 17.5209 13.1212H19.1805V2.81758H8.87682L8.87864 4.43025L8.86399 4.59366C8.78702 5.01775 8.41584 5.33934 7.96955 5.33934ZM1.90909 7.06057H14.0303C14.5324 7.06057 14.9394 7.46758 14.9394 7.96966V20.0909C14.9394 20.5929 14.5324 21 14.0303 21H1.90909C1.40701 21 1 20.5929 1 20.0909V7.96966C1 7.46758 1.40701 7.06057 1.90909 7.06057Z"
        fill={getSemanticTextColor(color)}
      />
    </svg>
  </DefaultIconWrapper>
);
